export default __webpack_public_path__ + "static/media/yape.ffae6ecd.png";